import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../assets/styles/clientAssign.css";
import config from "../../config";
import Rotatedown from "../../assets/Francias/rotatedown.svg";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp, faXmark } from "@fortawesome/free-solid-svg-icons";

function ClientAssign({ closePopup, clientData }) {
  const [tools, setTools] = useState([]);
  const [values, setValues] = useState([]);
  const [selectedTools, setSelectedTools] = useState({});
  const [summaryPopupOpen, setSummaryPopupOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const closeSummaryPopup = () => {
    setSummaryPopupOpen(false);
  };

  const [formData, setFormData] = useState({
    tool_camera: [],
    amount_paid: "",
    password: "", 
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (!formData.amount_paid || !formData.password || Object.keys(selectedTools).length === 0) {
        toast.error("All fields are required and tools must be selected.");
        return;
      }
  
      const payload = {
        tool_camera: Object.entries(selectedTools).reduce((acc, [id, tool]) => {
          acc[id] = tool.count;
          return acc;
        }, {}),
        amount_paid: formData.amount_paid,
        password: formData.password,
        email: clientData.email,
        client_id: clientData.id,
      };
 
      console.log("Payload being sent:", payload); 
      const response = await axios.post(`${config.apiBaseUrl}/admin/assigntoolclient`, payload); 
      if (response.data.status === "success") {
        toast.success("Purchase completed! Email sent successfully.");
        setTimeout(() => {
          setFormData({ tool_camera: [], amount_paid: "", password: "" });
          setSelectedTools ("");
          setValues(tools.map(() => 0)); 
          closeSummaryPopup();
        }, 2000);
      } else {
        toast.error(response.data.msg || "Failed to process the request.");
      }
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        console.log("Error Details:", error.response.data);
      }
      toast.error("Failed to process the request.");
    }finally {
      setLoading(false); // Reset loading when API call completes
    }
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlesummaryOpen = () => {
    setSummaryPopupOpen(true);
  };
  const handleClosesummary = () => {
    setSummaryPopupOpen(false);
  };

  const fetchTools = async () => {
    try {
      const response = await axios.get(`${config.apiBaseUrl}/admin/gettools`);
      setTools(response.data.data);
    } catch (err) {
      console.error("Error fetching tools:", err);
      toast("Failed to fetch tools. Please try again later.");
    }
  };

  useEffect(() => {
    fetchTools();
  }, []);

  useEffect(() => {
    if (tools.length > 0) {
      setValues(tools.map(() => 0));
    }
  }, [tools]);

  const handleIncrement = (index) => {
    setValues((prev) =>
      prev.map((value, i) => (i === index ? value + 1 : value))
    );
  };

  const handleDecrement = (index) => {
    setValues((prev) =>
      prev.map((value, i) => (i === index && value > 0 ? value - 1 : value))
    );
  };

  const handleManualInput = (index, newValue) => {
    const numericValue = parseInt(newValue, 10);
    setValues((prev) =>
      prev.map((value, i) =>
        i === index ? (isNaN(numericValue) || numericValue < 0 ? 0 : numericValue) : value
      )
    );
  };

  const handleCheckboxChange = (index, option) => {
    setSelectedTools((prev) => {
      const newSelected = { ...prev };
      if (newSelected[option.usecase_id]) {
        delete newSelected[option.usecase_id];
      } else {
        newSelected[option.usecase_id] = {
          label: option.label,
          count: values[index] || 0,
        };
      }
      return newSelected;
    });
  };

  const handleNext = () => {
    if (Object.keys(selectedTools).length === 0) {
      toast.error("Please select at least one tool before proceeding.");
      return;
    }
  
    const updatedSelectedTools = { ...selectedTools };
    tools.forEach((tool, index) => {
      if (updatedSelectedTools[tool.usecase_id]) {
        updatedSelectedTools[tool.usecase_id].count = values[index];
      }
    });
    const hasZeroCount = Object.values(updatedSelectedTools).some(
      (tool) => tool.count === 0
    );
    if (hasZeroCount) {
      toast.error("Tool count cannot be 0 for selected tools.");
      return;
    }
    setSelectedTools(updatedSelectedTools);
    handlesummaryOpen();
  };
  
  
  return (
    <div className="c-cm">
    
      <h4 className="franchiseheadtxt ms-2">Client Plans Assign</h4>
      <div className="clientAssign-container">
        <h5>Select tools out of {tools.length}</h5>
        <div className="accordion itemfrichisediv row">
          <div className="col-lg-6 col-6">
            <h5 className="mb-0 franchistoolhead">Tool</h5>
          </div>
          <div
            className="col-lg-6 col-6 d-flex justify-content-end align-items-center"
            style={{ cursor: "pointer" }}
          >
            <img src={Rotatedown} alt="icon" />
          </div>
        </div>
        <div className="accordion-content  mt-2">
          {tools.map((option, index) => {
          const purchestcount = typeof clientData.tool_camera === 'string' 
          ? JSON.parse(clientData.tool_camera || "{}")
          : clientData.tool_camera || {};
            const usecaseId = option.usecase_id;
            const usecaseCamer = purchestcount[usecaseId] || 0;
            return (
              <div key={tools.usecase_id} className="mb-0">
                <div className="row">
                  <div className="col-6  d-flex align-items-center">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`checkbox-${index}`}
                      onChange={() => handleCheckboxChange(index, option)}
                      checked={!!selectedTools[usecaseId]}
                    />
                    <label
                      htmlFor={`checkbox-${index}`}
                      className="ms-2 mt-2 align-items-center"

                    >
                      {option.label}
                    </label>
                  </div>
                  <div className="col-6 d-flex justify-content-end ">
                    <div className="d-flex align-items-center">
                      <input
                        type="text"
                        value={values[index] || 0}
                        onChange={(e) => handleManualInput(index, e.target.value)}
                        className="assigniput text-center"
                        style={{ width: "60px" }}
                      />
                      <div className="d-flex flex-column ms-2">
                        <span onClick={() => handleIncrement(index)} className="facateupbtn" > <FontAwesomeIcon icon={faCaretUp} /></span>
                        <span onClick={() => handleDecrement(index)} className="facatedownbtn"   > <FontAwesomeIcon icon={faCaretDown} /></span>
                      </div>
                      <div className="ms-3" style={{ width: "40px" }}> <span className=" remaninghistory">: {usecaseCamer}</span></div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="d-flex justify-content-end mt-3">
          <button className="franchisassignbtn" onClick={handleNext}>Next</button>
        </div>
        {summaryPopupOpen && (          
        <div className="clientassignpopup">
            <ToastContainer />
          <div className="clientassignpopupcontent">
            <p className="clientromvepop mt-2 "><FontAwesomeIcon icon={faXmark} onClick={handleClosesummary} /></p>
            <div className="">
              <h5 className="clientassigtxt mb-2">Summary -</h5>
            </div>
            <div>
              <h5 className="mb-3 summarytag text-ceneter">Selected tools </h5>
              <div className="d-flex flex-column ms-1">
                {Object.entries(selectedTools).map(([key, tool]) => (
                  <div key={key} className="d-flex justify-content-between mb-2" style={{ width: '256px' }}>
                    <span>{tool.label}</span>
                    <span style={{ width: '40px' }}><strong>:</strong> {tool.count}</span>
                  </div>
                ))}
              </div>

              <div class="row ">
                <div className='col-5 mt-2'>Enter amount</div>
                <div className='col-7 mt-2'> <strong>:</strong>  <input type="text"  name="amount_paid"
                value={formData.amount_paid}
                onChange={handleChange} placeholder='Enter amount' className='input-passcontent' /> </div>
                <div className='col-5 mt-2'>Password</div>
                <div className='col-7 mt-2'>  <strong>:</strong>  < input type="password"   name="password"
               value={formData.password}
               onChange={handleChange} placeholder='Enter password' className='input-passcontent' /> </div>
              </div>
              <div className="d-flex justify-content-end mt-3">
                <button type='button' className="franchisassignbtn"  disabled={loading} onClick={handleSubmit}>{loading ? "Assigning..." : "Assign"}</button>
              </div>
            </div>
          </div>
        </div>
      )}
      </div>
      
      <div className='row mt-2'>
        <div className='d-flex justify-content-end '>
          <button type="button" className='btn btn-danger me-1 '  onClick={closePopup}>Close</button>
        </div>
      </div>
    </div>
  );
}
export default ClientAssign;

